<div class="popup-header">
    <div class="risk-popup-title">
      <img class="risk-img" [src]="riskIcon" alt="Issues/Risks">
      <h4 class="popup-title">Confirm Risk Action</h4>
  
    </div>
  </div>

  <div class="popup-body">
    <div class="checked-risks-block">
      <span class="popup-text">Below items will be moved to Risk Register</span>
      <div class="risk-popup-block">
        <div class="risk-items">
          <table class="risk-item-table">
            <thead>
              <tr class="header-row">
                <th scope="col">Risks</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngIf="selectedRisks.length">
                <tr *ngFor="let risk of selectedRisks">
                  <td> {{risk.RiskStatment || ' Risk: '+risk.IssueId}}</td>
                 
                </tr>
              </ng-container>
              <ng-container *ngIf="!selectedRisks.length">
                <tr>
                  <td>
                    <div class="no-data-block">
                      <img [src]="noDataImg" alt="No Data Available">
                      <span>No items to select</span>
                    </div>
                  </td>
                </tr>
              </ng-container>
  
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="unchecked-risks-block">
      <span class="popup-text">Please select the action to be performed on the below items in DHD FLM</span>
      <div class="risk-popup-block">
        <div class="risk-items">
          <table class="risk-item-table">
            <thead>
              <tr class="header-row">
                <th scope="col" >Issues</th>
                <th scope="col" class="action-column">Action</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngIf="uncheckedRisks.length">
                <tr *ngFor="let risk of uncheckedRisks">
                  <td> {{risk.RiskStatment || ' Issue: '+risk.IssueId}}</td>
                  <td>          
                    <div class="radio-buttons">
                    <label>
                      <input type="radio" name="action_{{risk.IssueId}}" value="keep" (change)="handleRiskAction(risk.IssueId, 'keep')"
                      [checked]="!cancelRisksList.includes(risk.IssueId)"> Keep Open
                    </label>
                    <label>
                      <input type="radio" name="action_{{risk.IssueId}}" value="cancel" (change)="handleRiskAction(risk.IssueId, 'cancel')"
                      [checked]="cancelRisksList.includes(risk.IssueId)"> Close
                    </label>
                  </div>
                </td>
                </tr>
              </ng-container>
              <ng-container *ngIf="!uncheckedRisks.length">
                <tr>
                  <td colspan="2">
                    <div class="no-data-block">
                      <img [src]="noDataImg" alt="No Data Available">
                      <span>No items to select</span>
                    </div>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  
  <div class="popup-footer">
    <button type="button" class="cancel-btn" (click)="closeModal()" tooltip="Close">Back</button>
    <!-- <button *ngIf="uncheckedRisks.length || selectedRisks.length" type="button" class="submit-btn" tooltip="Click to save" (click)="submitRisksToCancelAtFlm()"
       >Submit</button> -->
    <button *ngIf="uncheckedRisks.length || selectedRisks.length" type="button" class="submit-btn" tooltip="Click to submit" 
    (click)="riskOfficerSubmit()"
       >Submit</button>
  </div>
  